import React from 'react';
import PropTypes from 'prop-types'

import Male from '../../images/male.svg'
import Female from '../../images/female.svg'
import Group from '../../images/group.svg'

const TravellerTypes = ({ travellerTypes }) => (
  <React.Fragment>
    <p className="db-card-title">Traveller Types</p>
    <div className="row db-card-wrp db-travellertypes-body db-border-bottom">
      <div className="col-xs-4">
        <img src={Male} alt="Male" />
        <span>{travellerTypes.male} %</span>
      </div>
      <div className="col-xs-4">
        <img src={Female} alt="Female" />
        <span>{travellerTypes.female} %</span>
      </div>
      <div className="col-xs-4">
        <img src={Group} alt="Group" />
        <span>{travellerTypes.group} %</span>
      </div>
    </div>
  </React.Fragment>
)

TravellerTypes.propTypes = {
  travellerTypes: PropTypes.shape({
    male: PropTypes.number,
    female: PropTypes.number,
    group: PropTypes.number,
  })
};

export default TravellerTypes;
